import React, { useState, useRef, useEffect } from 'react';

/* ponytail: single width per usage; srcSet/sizes if layouts diversify.
   /_vercel/image only exists on Vercel — localhost serves the raw file. */
export const optimize = (src, width) =>
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? src
    : `/_vercel/image?url=${encodeURIComponent(src)}&w=${width}&q=75`;

const LazyImage = ({
  src,
  alt,
  width,
  height,
  className = '',
  isHero = false,
  optWidth = 1080,
  ...props
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    // Preload hero images immediately
    if (isHero) {
      setIsInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: '50px',
        threshold: 0.1
      }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, [isHero]);

  const handleLoad = () => {
    setIsLoaded(true);
  };

  return (
    <div ref={imgRef} className={`lazy-image-container ${className}`}>
      {isInView && (
        <img
          src={optimize(src, optWidth)}
          alt={alt}
          width={width}
          height={height}
          loading={isHero ? 'eager' : 'lazy'}
          onLoad={handleLoad}
          className={`lazy-image ${isLoaded ? 'loaded' : ''}`}
          style={{
            aspectRatio: width && height ? `${width} / ${height}` : 'auto'
          }}
          {...props}
        />
      )}
    </div>
  );
};

export default LazyImage;
